document.addEventListener('DOMContentLoaded', function () {
  const quantityInput = document.querySelector('.quantity-input');
  const variantSelect = document.querySelector('.variant-select');
  const form = document.getElementById('product-form');
  const hiddenVariantInput = document.querySelector('input[name="id"]');
  const mainImageContainer = document.getElementById('main-product-image');
  const thumbnails = document.querySelectorAll('.thumbnail');
  const variantFields = document.querySelectorAll('.variant-fields');

  // Preload images cache
  const imageCache = new Map();
  thumbnails.forEach(thumb => {
    const imageUrl = thumb.dataset.imageUrl;
    if (imageUrl && !imageCache.has(imageUrl)) {
      const img = new Image();
      img.src = imageUrl;
      imageCache.set(imageUrl, img);
    }
  });
  if (variantSelect) {
    Array.from(variantSelect.options).forEach(option => {
      const imageUrl = option.dataset.imageUrl;
      if (imageUrl && imageUrl !== '' && !imageCache.has(imageUrl)) {
        const img = new Image();
        img.src = imageUrl;
        imageCache.set(imageUrl, img);
      }
    });
  }

  // Helper: update price
  function updatePrice() {
  if (!quantityInput) return;
  const quantity = parseInt(quantityInput.value) || 1;
  let variantPrice = 0;

  if (variantSelect) {
    const selectedOption = variantSelect.selectedOptions[0];
    variantPrice = (parseFloat(selectedOption.dataset.price) || 0) ;
  } else if (hiddenVariantInput) {
    variantPrice = (parseFloat(hiddenVariantInput.dataset.price) || 0) / 100;
  }

  const total = quantity * variantPrice;
  const formatGBP = v => new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP' }).format(v);
  const optionTotalElement = document.querySelector('.option-total .price');
  const finalTotalElement = document.querySelector('.final-total .price');
  if (optionTotalElement) optionTotalElement.textContent = formatGBP(variantPrice);
  if (finalTotalElement) finalTotalElement.textContent = formatGBP(total);
}


  updatePrice();

  // Show/hide variant fields properly
  function showVariantFields(variantId) {
    variantFields.forEach(group => {
      if (group.dataset.variantId == variantId) {
        group.style.display = 'block';
        group.querySelectorAll('select, textarea, input').forEach(el => el.disabled = false);
      } else {
        group.style.display = 'none';
        group.querySelectorAll('select, textarea, input').forEach(el => el.disabled = true);
      }
    });
  }

  // Variant change
  if (variantSelect) {
    variantSelect.addEventListener('change', function () {
      const selectedOption = this.options[this.selectedIndex];
      hiddenVariantInput.value = this.value;

      // Show/hide fields
      showVariantFields(this.value);

      // Update main image
      const imageUrl = selectedOption.dataset.imageUrl;
      if (imageUrl) {
        let img = imageCache.has(imageUrl) ? imageCache.get(imageUrl).cloneNode() : new Image();
        img.src = imageUrl;
        img.className = 'featured-image';
        img.alt = document.querySelector('h1')?.textContent || 'Product image';
        mainImageContainer.innerHTML = '';
        mainImageContainer.appendChild(img);
      }

      updatePrice();
    });

    // Initial load
    showVariantFields(hiddenVariantInput.value || variantSelect.value);
  }

  // Quantity change
  if (quantityInput) quantityInput.addEventListener('change', updatePrice);

  // Thumbnail click
  thumbnails.forEach(thumb => {
    thumb.addEventListener('click', function () {
      const imageUrl = this.dataset.imageUrl;
      if (imageUrl) {
        let img = imageCache.has(imageUrl) ? imageCache.get(imageUrl).cloneNode() : new Image();
        img.src = imageUrl;
        img.className = 'featured-image';
        mainImageContainer.innerHTML = '';
        mainImageContainer.appendChild(img);
      }
    });
  });

  // Form submission via AJAX
  if (form && !form.dataset.listenerAttached) {
  form.dataset.listenerAttached = 'true';

  let isSubmitting = false;

  form.addEventListener('submit', function (e) {
    e.preventDefault();

    if (isSubmitting) return;
    isSubmitting = true;

    // Re-enable visible fields
    variantFields.forEach(group => {
      if (group.style.display !== 'none') {
        group.querySelectorAll('select, textarea, input').forEach(el => el.disabled = false);
      }
    });

    const formData = new FormData(form);
    const ids = formData.getAll('id');
    if (ids.length > 1) {
      formData.delete('id');
      formData.append('id', ids[0]);
    }

    const addButton = form.querySelector('.add-to-basket');

    if (!addButton.dataset.adding) {
      addButton.dataset.adding = 'true';
      addButton.textContent = 'Adding...';
      addButton.disabled = true;
    }
     console.log('Quantity sent:', formData.get('quantity'));
console.log('Variant ID sent:', formData.getAll('id'));
    fetch('/cart/add.js', { method: 'POST', body: formData })
      .then(r => r.ok ? r.json() : Promise.reject('Add to cart failed'))
      .then(() => fetch('/cart.js'))
      .then(r => r.json())
      .then(cart => {
        const cartCount = document.querySelector('.cart-count');
        if (cartCount) cartCount.textContent = cart.item_count;
        else if (cart.item_count > 0) {
          const cartLink = document.querySelector('.cart-link');
          if (cartLink) {
            const span = document.createElement('span');
            span.className = 'cart-count';
            span.textContent = cart.item_count;
            cartLink.appendChild(span);
          }
        }

        addButton.textContent = 'Added!';
        addButton.disabled = false;

        setTimeout(() => {
          addButton.textContent = 'Add to Basket';
          delete addButton.dataset.adding;
        }, 2000);

        isSubmitting = false;
      })
      .catch(err => {
        console.error(err);
        alert('Error adding to cart');
        addButton.textContent = 'Add to Basket';
        addButton.disabled = false;
        delete addButton.dataset.adding;
        isSubmitting = false;
      });
  });
}
});
